import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthTemplateComponent } from './auth-template/auth-template.component';

@NgModule({
  declarations: [
    AuthTemplateComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    AuthTemplateComponent,
  ],
})
export class ComponentsModule { }
